import React from 'react';

import './ExtraDescription.css';

const ExtraDescription = ({ content = '' }) => (
  <div
    className="visibilityAuto"
    dangerouslySetInnerHTML={{ __html: content }}
  ></div>
);

export default ExtraDescription;
